import { render, staticRenderFns } from "./Landing-Layout.vue?vue&type=template&id=9ed01d68&scoped=true"
import script from "./Landing-Layout.vue?vue&type=script&lang=js"
export * from "./Landing-Layout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ed01d68",
  null
  
)

export default component.exports